// extracted by mini-css-extract-plugin
export default {"faq-section":"style_faq-section__pKUD+","section-title":"style_section-title__65hsH","bottomTxt":"style_bottomTxt__W-Sn0"};